import React from 'react'
import classnames from 'classnames'
import { useGesture } from '../GestureProvider'
import { DragEventData } from '../../types/gesture-types'
import { HandleCursor, HandleIdentifier } from '../../types/types'

type HandleProps = {
  handle: HandleIdentifier
  x: number
  y: number
  width: number
  height: number
  cursor: HandleCursor
  onPanStart: (event: DragEventData, handle: HandleIdentifier) => void
  onPanMove: (event: DragEventData, handle: HandleIdentifier) => void
  onPanEnd: (event: DragEventData, handle: HandleIdentifier) => void
}

const Handle: React.FC<HandleProps> = props => {
  const { x, y, width, height, handle, cursor = 'auto', onPanStart, onPanMove, onPanEnd } = props

  const ref = React.useRef(null)
  const { bindGesture } = useGesture()

  // Use our gesture context to bind gesture handlers
  const bind = bindGesture(
    {
      onDragStart: ({ event, deltaX, deltaY }) => {
        onPanStart({ event, deltaX, deltaY }, handle)
      },
      onDragMove: ({ event, deltaX, deltaY }) => {
        onPanMove(
          {
            event,
            deltaX,
            deltaY,
          },
          handle
        )
      },
      onDragEnd: ({ event, deltaX, deltaY }) => {
        onPanEnd({ event, deltaX, deltaY }, handle)
      },
    },
    {
      axis: 'x',
    }
  )

  const handleStyle: React.CSSProperties = {
    top: y,
    left: x,
    width: width,
    height: height,
    marginTop: (height / 2) * -1,
    marginLeft: (width / 2) * -1,
    cursor: cursor,
    touchAction: 'pan-y', // Allow vertical scrolling, prevent horizontal browser gestures
  }
  const gripStyle: React.CSSProperties = {
    height: Math.round(height * 0.4),
  }
  const className = classnames('handle', `handle--${handle}`)
  return (
    <div className={className} data-handle={handle} style={handleStyle} ref={ref} {...bind()}>
      <div className="gripper">
        <div className="grip" style={gripStyle}></div>
        <div className="grip" style={gripStyle}></div>
        <div className="grip" style={gripStyle}></div>
      </div>
    </div>
  )
}
export default Handle
